import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/images/send_arrow.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "section-container" }
const _hoisted_3 = { class: "section-name default-text" }
const _hoisted_4 = { class: "default-text-orange" }
const _hoisted_5 = { class: "roles-div" }
const _hoisted_6 = { class: "buttons-container" }
const _hoisted_7 = { class: "checkboxes-container" }
const _hoisted_8 = {
  key: 0,
  class: "checkbox-div"
}
const _hoisted_9 = { class: "section-container" }
const _hoisted_10 = { class: "section-name-what default-text" }
const _hoisted_11 = { class: "default-text-orange" }
const _hoisted_12 = { class: "select-menu" }
const _hoisted_13 = {
  key: 0,
  class: "suggestion-container"
}
const _hoisted_14 = { class: "section-name-how default-text" }
const _hoisted_15 = { class: "suggestion-element-wrapper" }
const _hoisted_16 = { class: "suggestion-tag-selection-button-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "our-suggestion-wrapper"
}
const _hoisted_18 = { class: "small-text-grey suggestion-message" }
const _hoisted_19 = { class: "suggestions-block" }
const _hoisted_20 = {
  key: 0,
  class: "no-suggestion-text small-text-grey"
}
const _hoisted_21 = { class: "user-suggestion-wrapper" }
const _hoisted_22 = {
  key: 0,
  class: "small-text-grey suggestion-message"
}
const _hoisted_23 = { class: "suggestions-block" }
const _hoisted_24 = {
  key: 0,
  class: "tag-selection-text-area-wrapper"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "technologies-similarity"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "medium-text-grey" }, "Do you mean", -1)
const _hoisted_29 = { class: "similarity-button-container" }
const _hoisted_30 = { class: "similarity-button-container" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "medium-text-grey question-mark" }, "?", -1)
const _hoisted_32 = {
  key: 2,
  class: "how-warning-message small-text-salmon"
}
const _hoisted_33 = { class: "value-container-wrap" }
const _hoisted_34 = { class: "section-name-why default-text" }
const _hoisted_35 = { class: "value-container" }
const _hoisted_36 = {
  key: 0,
  class: "small-text why-text"
}
const _hoisted_37 = {
  key: 1,
  class: "checkbox-wrapper"
}
const _hoisted_38 = { class: "tag-selection-text-area-wrapper" }
const _hoisted_39 = {
  key: 0,
  class: "default-text or"
}
const _hoisted_40 = {
  key: 2,
  class: "small-text custom-value-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profileButton = _resolveComponent("profileButton")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_multipleCheckboxSelect = _resolveComponent("multipleCheckboxSelect")!
  const _component_ta_button = _resolveComponent("ta-button")!

  return (!_ctx.timeEntryLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.firstSectionName), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.requiredSymbol), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profilesOrdered.values(), (profile, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tag-selection-button-wrapper",
                  key: index
                }, [
                  profile
                    ? (_openBlock(), _createBlock(_component_profileButton, {
                        key: 0,
                        profile: profile,
                        selectedProfile: _ctx.selectedProfile,
                        onClick: _ctx.checkRequiredValues,
                        onNewProfile: ($event: any) => (
                _ctx.selectProfile(profile.ID, profile.profile_name, true, true)
              )
                      }, null, 8, ["profile", "selectedProfile", "onClick", "onNewProfile"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.noProjectForDefaultProfile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.defaultProfileRetrieved)
                      ? (_openBlock(), _createBlock(_component_checkbox, {
                          key: 0,
                          checkboxText: _ctx.firstCheckboxText,
                          checkActive: _ctx.defaultProfileRetrieved,
                          color: 'grey-60',
                          size: 'medium',
                          onToggleCheckBox: _ctx.removeDefaultRole
                        }, null, 8, ["checkboxText", "checkActive", "onToggleCheckBox"]))
                      : _createCommentVNode("", true),
                    (!_ctx.defaultProfileRetrieved && _ctx.selectedProfile)
                      ? (_openBlock(), _createBlock(_component_checkbox, {
                          key: 1,
                          checkboxText: _ctx.secondCheckboxText,
                          checkActive: _ctx.setDefaultProfile,
                          color: 'grey-60',
                          size: 'medium',
                          onToggleCheckBox: _ctx.setDefaultRole
                        }, null, 8, ["checkboxText", "checkActive", "onToggleCheckBox"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.secondSectionName), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.requiredSymbol), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_multipleCheckboxSelect, {
              options: _ctx.options,
              clickedNewLabel: _ctx.newLabelClicked,
              onResetSelectActions: _ctx.resetActions,
              onClick: _ctx.checkRequiredValues
            }, null, 8, ["options", "clickedNewLabel", "onResetSelectActions", "onClick"])
          ])
        ]),
        (_ctx.showSuggestionArea)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.thirdSectionName), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (!_ctx.HideOurSuggestionsBlock)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("tag-selection.our-suggestion")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.showNoSuggestionText)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("tag-selection.no-suggestion")), 1))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestionMapData, (suggestion, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              (!suggestion.isRemovable)
                                ? (_openBlock(), _createBlock(_component_ta_button, {
                                    key: 0,
                                    class: _normalizeClass(["suggestion-button", _ctx.buttonToggleClass(suggestion)]),
                                    closeHover: suggestion.isRemovable,
                                    customClass: _ctx.techButtonClass(suggestion.isRemovable),
                                    backgroundColor: 'dark-text',
                                    text: suggestion.name,
                                    onClick: ($event: any) => (_ctx.toggleSuggestion(suggestion))
                                  }, null, 8, ["closeHover", "customClass", "text", "class", "onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    (_ctx.showUserTechnologies)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t("tag-selection.user-suggestion")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestionMapData, (suggestion, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (suggestion.isRemovable)
                            ? (_openBlock(), _createBlock(_component_ta_button, {
                                key: 0,
                                class: _normalizeClass(["suggestion-button", _ctx.buttonToggleClass(suggestion)]),
                                closeHover: suggestion.isRemovable,
                                customClass: _ctx.techButtonClass(suggestion.isRemovable),
                                backgroundColor: 'dark-text',
                                text: suggestion.name,
                                onClick: ($event: any) => (_ctx.toggleSuggestion(suggestion))
                              }, null, 8, ["closeHover", "customClass", "text", "class", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (!_ctx.insertedValue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("input", {
                        onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.checkTechnologySimilarity && _ctx.checkTechnologySimilarity(...args)), ["enter"])),
                        type: "text",
                        placeholder: "Write additional technologies",
                        ref: "suggestionInput",
                        class: "suggestion-text-area small-text"
                      }, null, 544),
                      _createElementVNode("div", {
                        class: "suggestion-image-div",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkTechnologySimilarity && _ctx.checkTechnologySimilarity(...args)))
                      }, _hoisted_26)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.insertedValue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ta_button, {
                          class: "similarity-button",
                          text: _ctx.insertedValue,
                          backgroundColor: 'gray',
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addToSuggestion(_ctx.insertedValue, true)))
                        }, null, 8, ["text"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_ta_button, {
                          class: "similarity-button",
                          text: _ctx.bestTechnologyMatch,
                          backgroundColor: 'gray',
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addToSuggestion(_ctx.bestTechnologyMatch, false)))
                        }, null, 8, ["text"])
                      ]),
                      _hoisted_31
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.$t("tag-selection.error-suggestion")), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.fourthSectionName), 1),
          _createElementVNode("div", _hoisted_35, [
            (_ctx.task.custom_fields.why)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.task.custom_fields.why), 1))
              : _createCommentVNode("", true),
            (_ctx.task.custom_fields.why)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_checkbox, {
                    class: "value-checkbox",
                    checkboxText: _ctx.valueCheckboxText,
                    checkActive: _ctx.givenValueApproved,
                    color: 'grey-60',
                    size: 'medium',
                    onToggleCheckBox: _ctx.approveGivenValue
                  }, null, 8, ["checkboxText", "checkActive", "onToggleCheckBox"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              (_ctx.task.custom_fields.why)
                ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.$t("generic-text.or")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("input", {
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addCustomValue && _ctx.addCustomValue(...args))),
                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addCustomValue && _ctx.addCustomValue(...args))),
                maxlength: "90",
                ref: "customSuggestionInput",
                class: "text-area-why small-text",
                type: "text",
                placeholder: "Write the value of this activity"
              }, null, 544)
            ]),
            (this.customValueLength.length === 90)
              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.$t("tag-selection.value-error")), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}